import { gridClasses } from '@mui/x-data-grid-pro';
import { forwardRef } from 'react';

export interface DataTableExpandableCellProps {
  children: React.ReactNode;
}

export const DataTableExpandableCell = forwardRef<HTMLDivElement, DataTableExpandableCellProps>(
  function DataTableExpandableCell({ children }, ref) {
    return (
      // Use the same className as MUI does for their default `renderCell` for ease of consistent
      // behavior and styling.
      // We intentionally do not include the "title" attribute like MUI does because it's not needed when the user
      // can expand the cell to see the full value.
      // https://github.com/mui/mui-x/blob/v6.x/packages/grid/x-data-grid/src/components/cell/GridCell.tsx#L776-L783
      <div className={gridClasses.cellContent} ref={ref} role="presentation">
        {children}
      </div>
    );
  }
);
